import { render } from "./HiddenField.vue?vue&type=template&id=07450844"
import script from "./HiddenField.vue?vue&type=script&lang=js"
export * from "./HiddenField.vue?vue&type=script&lang=js"
script.render = render

export default script